
import { useState, useMemo } from "react"
import axios from "axios"
import { Searchbar } from "./Searchbar"
import { WeatherCard } from "./WeatherCard"

export const WeatherApp = () => {
    const [weather, setWeather] = useState(null)
    const [error, setError] = useState("")
    const [load, setLoad] = useState(false)

    const API_KEY = process.env.REACT_APP_OPENWEATHER_API_KEY
    const API_URL = `https://api.openweathermap.org/data/2.5/weather`

    const gradientClass = useMemo(() => {
        if (!weather) return "from-gray-900 to-black";
        const temp = weather.main.temp;
        if (temp > 30) return "from-orange-950 via-red-900 to-black";
        if (temp > 20) return "from-emerald-950 via-teal-900 to-slate-900";
        if (temp > 10) return "from-slate-900 via-blue-950 to-gray-900"
        return "from-slate-950 via-gray-900 to-black";
    }, [weather]);

    const getWeather = async (city) => {
        setLoad(true)
        setError("")
        try {
            const { data } = await axios.get(`${API_URL}?q=${city}&units=metric&appid=${API_KEY}`)
            console.log("Weather Data:", data)
            setWeather(data)
        } catch (err) {
            setError("City not found")
            setWeather(null)
        } finally {
            setLoad(false)
        }
    }

    return (
        <div className={`min-h-screen flex items-center justify-center bg-gradient-to-br
         ${gradientClass} transition-colors duration-1000 p-4 sm:p-6 md:items-center`}>
            <div className="w-full max-w-md bg-white/10 backdrop-blur-md rounded-[2rem] 
             p-6 sm:p-8 border border-white/20 shadow-2xl transition-all duration-500 my-auto">
                <h1 className="text-2xl sm:text-2xl font-bold font-poppins text-center text-white mb-6 tracking-tight">
                    Weather App
                </h1>

                <Searchbar getWeather={getWeather} />

                <div className="mt-2 min-h-[200px] flex flex-col justify-center">
                    {load ? (
                        <div className="flex flex-col items-center space-y-4 animate-in fade-in zoom-in duration-300">
                            <div className="w-10 h-10 border-4 border-white/20 border-t-white rounded-full animate-spin"></div>
                            <p className="text-white/60 text-sm animate-pulse font-medium">Fetching Weather data...</p>
                        </div>
                    ) : (
                        <>
                            {error && (
                                <div className="flex flex-col items-center py-8 animate-in fade-in slide-in-from-bottom-4 duration-700">
                                    <div className="text-5xl mb-3 opacity-50 filter grayscale">☁️</div>
                                    <p className="text-white/80 text-lg font-light tracking-wide">Check Your spelling</p>
                                    <p className="text-white/40 text-[12px] mt-4 uppercase tracking-[0.2em]">{error}</p>
                                </div>
                            )}
                            {weather && !error && (
                                <div className="animate-in fade-in zoom-in duration-500">
                                    <WeatherCard weather={weather} />
                                </div>
                            )}
                            {!weather && !error && (
                                <div className="text-center py-12 animate-in fade-in duration-1000">
                                    <p className="text-white/30 text-sm italic font-light">
                                        Enter a city name to explore the weather
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}